<template>
  <el-tooltip :placement="placement" :effect="effect" :tabindex="-1">
    <template slot="content">
      <slot>{{ tooltip }}</slot>
    </template>
    <el-button :type="type" style="padding: 12px"
      :icon="icon || 'el-icon-' + type"
      v-bind="$attrs"
      :tabindex="-1">
      <slot name="content" v-if="content || $slots.content">
        {{ content }}
      </slot>
    </el-button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'TooltipButton',
  props: {
    tooltip: String,
    content: String,
    type: {
      type: String,
      default: 'info',
    },
    icon: String,
    placement: String,
    effect: {
      type: String,
      default: 'light',
    },
  },
}
</script>
